/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 * @author Maxim Fedorov
 * @author Yakov.Gushchin
 * @version 1.0.5
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../theme';
import { fontSizeSmall } from '../../../../theme/default/global';
import { IAttrStyled } from '../../../../types/globalTypes';

const DayCellTdStyled = styled.div.attrs((props: IAttrStyled) => ({
    className: `${props.className} range-date-picker__calendar-day-cell`,
}))<IAttrStyled>`
    width: 32px;
    border: none;
    padding: 0;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
    font-size: ${fontSizeSmall};

    &.off, &.off.in-range, &.off.start-date, &.off.end-date {
        visibility: hidden;
        border-color: transparent;
        background-color: ${colors.CalendarCellBgColor};
        color: ${colors.CalendarCellColor};

    };
    &.invisible {
        visibility: hidden;
    };
`;

const WeekCellTdStyled = styled.div.attrs({
    className: 'range-date-picker__calendar-week-cell',
})`
    font-size: 80%;
    color: ${colors.WeekCellColor};
`;

export {
    DayCellTdStyled,
    WeekCellTdStyled,
};
